// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rj-2";
export var chatLink = "_rj-0";
export var chatText = "_rj-1";